import { Stack, styled } from '@mui/material';

import breakpoints from '../../../constants/breakpoints';
import Popover from '../Popover';

export const DialogActions = styled('footer')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'var(--spacing-medium)',
  justifyContent: 'flex-start',
}));

export const DialogTitle = styled('header')(() => ({
  fontSize: 'var(--font-xl)',
}));

export const StyledPopover = styled(Popover)(() => ({
  '& .MuiPopover-paper': {
    border: 'none',
  },
}));

export const Wrapper = styled(Stack)(() => ({
  gap: 'var(--spacing-medium)',
  maxWidth: breakpoints.tabletS / 2,
  padding: 'var(--spacing-large)',
}));
